module.exports = __webpack_public_path__ + "media/images/Rolling-1s-200px-67ec831c75745fc033845ebfe27c0056.gif";